import {
  combineCityState,
  buildChildStatus,
} from '../../../utils/transformers/helpers';

export function chapter4Transform(formData) {
  const parsedFormData = JSON.parse(formData);
  const transformedValue = { ...parsedFormData };

  // 2026 version - set howMarriageEnded to 'divorce' or 'other' based on howMarriageEndedDivorce
  if (
    parsedFormData.claimantRelationship === 'SURVIVING_SPOUSE' &&
    !parsedFormData.marriedToVeteranAtTimeOfDeath
  ) {
    transformedValue.howMarriageEnded = parsedFormData?.howMarriageEndedDivorce
      ? 'divorce'
      : 'other';
  }

  // combine city and state/country for place of marriage and place of separation
  // for marriage and each previous/veteran previous marriage
  if (
    parsedFormData?.marriageToVeteranEndLocation ||
    parsedFormData?.marriageToVeteranEndDeathLocation
  ) {
    transformedValue.placeOfMarriageTermination =
      parsedFormData?.marriageToVeteranEndLocation
        ? combineCityState(
            parsedFormData.marriageToVeteranEndLocation?.city,
            parsedFormData.marriageToVeteranEndLocation?.state ||
              parsedFormData.marriageToVeteranEndLocation?.otherCountry,
          )
        : combineCityState(
            parsedFormData.marriageToVeteranEndDeathLocation?.city,
            parsedFormData.marriageToVeteranEndDeathLocation?.state ||
              parsedFormData.marriageToVeteranEndDeathLocation?.otherCountry,
          );
  }

  if (parsedFormData?.marriageToVeteranStartLocation) {
    transformedValue.placeOfMarriage = combineCityState(
      parsedFormData.marriageToVeteranStartLocation?.city,
      parsedFormData.marriageToVeteranStartLocation?.state ||
        parsedFormData.marriageToVeteranStartLocation?.otherCountry,
    );
  }

  if (parsedFormData?.spouseMarriages?.length) {
    transformedValue.spouseMarriages = parsedFormData.spouseMarriages.map(
      marriage => {
        return {
          ...marriage,
          locationOfMarriage: combineCityState(
            marriage.locationOfMarriage?.city,
            marriage.locationOfMarriage?.state ||
              marriage.locationOfMarriage?.otherCountry,
          ),
          locationOfSeparation: combineCityState(
            marriage.locationOfSeparation?.city,
            marriage.locationOfSeparation?.state ||
              marriage.locationOfSeparation?.otherCountry,
          ),
          reasonForSeparationExplanation: marriage?.separationExplanation || '',
        };
      },
    );
  }

  if (parsedFormData?.veteranMarriages?.length) {
    transformedValue.veteranMarriages = parsedFormData.veteranMarriages.map(
      marriage => {
        return {
          ...marriage,
          locationOfMarriage: combineCityState(
            marriage.locationOfMarriage?.city,
            marriage.locationOfMarriage?.state ||
              marriage.locationOfMarriage?.otherCountry,
          ),
          locationOfSeparation: combineCityState(
            marriage.locationOfSeparation?.city,
            marriage.locationOfSeparation?.state ||
              marriage.locationOfSeparation?.otherCountry,
          ),
          reasonForSeparationExplanation: marriage?.separationExplanation || '',
        };
      },
    );
  }

  // The 2026 dependent pages collect one child at the top level. The backend
  // still expects the veteransChildren array used by the previous form.
  const childFields = [
    'childFullName',
    'childSocialSecurityNumber',
    'noSsn',
    'childDateOfBirth',
    'bornOutsideUs',
    'birthPlace',
    'relationship',
    'inSchool',
    'seriouslyDisabled',
    'hasBeenMarried',
  ];
  const children = [...(parsedFormData.veteransChildren || [])];
  if (parsedFormData.childFullName || parsedFormData.childDateOfBirth) {
    const child = {};
    childFields.forEach(key => {
      if (parsedFormData[key] !== undefined) {
        child[key] = parsedFormData[key];
      }
    });
    children.push(child);
  }
  childFields.forEach(key => delete transformedValue[key]);

  if (children.length) {
    transformedValue.veteransChildren = children.map(child => {
      return {
        ...child,
        childPlaceOfBirth: combineCityState(
          child.birthPlace?.city,
          child.birthPlace?.state || child.birthPlace?.otherCountry,
        ),
        childStatus: buildChildStatus(child),
      };
    });
  }

  // yes/no for separation due to marital discord...
  if (parsedFormData?.separationDueToAssignedReasons) {
    if (
      parsedFormData.separationDueToAssignedReasons ===
      'RELATIONSHIP_DIFFERENCES'
    ) {
      transformedValue.separationDueToAssignedReasons = true;
    } else {
      transformedValue.separationDueToAssignedReasons = false;
    }
  }
  // combine dates of marriage
  if (
    parsedFormData?.marriageToVeteranStartDate ||
    parsedFormData?.marriageToVeteranEndDate
  ) {
    transformedValue.marriageDates = {
      from: parsedFormData.marriageToVeteranStartDate || '',
      to: parsedFormData.marriageToVeteranEndDate || '',
    };
  }

  // delete unused fields
  delete transformedValue.marriageToVeteranEndLocation;
  delete transformedValue.marriageToVeteranEndDeathLocation;
  delete transformedValue.marriageToVeteranStartLocation;
  delete transformedValue.marriageToVeteranStartDate;
  delete transformedValue.marriageToVeteranEndDate;
  delete transformedValue.marriageToVeteranEndOutsideUs;
  delete transformedValue.howMarriageEndedDivorce;

  return JSON.stringify(transformedValue);
}
